import { z } from 'zod';

export const errorBodySchema = z.object({ message: z.string() });

// MDH appends a debug dump (`--- context ---` + key/value lines) to the
// message; only the part before it is meant for users.
const CONTEXT_SEPARATOR = '\n--- context ---';

export const toUserMessage = (message: string): string | undefined =>
  message.split(CONTEXT_SEPARATOR)[0]?.trim() || undefined;

const errorResponseSchema = z.object({
  response: z.object({ data: errorBodySchema }),
});

// The user-facing message the datasets API puts in an error response, if any.
export const getErrorMessage = (error: unknown): string | undefined => {
  const parsed = errorResponseSchema.safeParse(error);
  return parsed.success
    ? toUserMessage(parsed.data.response.data.message)
    : undefined;
};
